import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { generateId } from "@kma-core/client-web-attribution";

import { useAppData, useUserStore } from "providers/RootStoreProvider";
import { getAllSearchParams } from "helpers/getAllSearchParams";
import { IpBasedAccessControl } from "./wrappers";
import { useFbConfigData } from "./hooks";
import { webAttribution } from "services/attributionConfig";

export const AmplitudeProvider = observer(({ children }: React.PropsWithChildren) => {
    const { setAmplitudeUserId, amplitudeUserId, setIsAttributionSent } = useAppData();
    const { userProfile, setWebSessionLoading } = useUserStore();
    const { abTestData, allAbTestFlags } = useFbConfigData();
    const [searchParams] = useSearchParams();

    const allQueryParams = getAllSearchParams(searchParams);
    const { usid: usidQueryParam } = allQueryParams as Record<string, string>;

    const usid = userProfile?.amplitudeSessionId || amplitudeUserId || usidQueryParam || generateId();

    useEffect(() => {
        (async () => {
            if (!abTestData) return;

            try {
                if (amplitudeUserId !== "") {
                    await webAttribution({ amplitudeUserId, abTests: allAbTestFlags });
                    setIsAttributionSent(true);
                }

                setAmplitudeUserId(usid);
                setWebSessionLoading(false);
            } catch (err) {
                console.error("Failed to provide Amplitude identification");
            }
        })();
    }, [userProfile?.amplitudeSessionId, amplitudeUserId, abTestData]);

    return <IpBasedAccessControl>{children}</IpBasedAccessControl>;
});
